<div class="flex flex-col flex-auto min-w-0">
  <!-- Main -->
  <div class="flex-auto p-6 sm:pt-10">
    <!-- CONTENT GOES HERE -->
    <div class="min-h-400 rounded-2xl">
      <!-- Main -->
      <div class="flex-auto -mt-px">
        <div class="w-full">
          <a
            class="inline-flex items-center leading-6 text-primary hover:underline"
            (click)="retour()"
          >
            <span class="inline-flex items-center">
              <mat-icon
                class="icon-size-5 text-current"
                [svgIcon]="'heroicons_solid:arrow-small-left'"
              />
              <span class="ml-1.5 font-medium leading-5" style="cursor: pointer"
                >Retour</span
              >
            </span>
          </a>
          <div
            class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 w-full min-w-0"
          >
            <div
              class="flex flex-col flex-auto col-span-3 overflow-hidden bg-card rounded-2xl p-10"
            >
              <div class="text-2xl font-semibold leading-tight mb-4 mt-4">
                Articles
              </div>
              <!-- Filter -->
              <div
                class="flex flex-col sm:flex-row items-center justify-between w-full max-w-xs sm:max-w-none"
              >
                <mat-form-field class="f w-full sm:w-36 lg:w-50 md:w-50">
                  <mat-select
                    [value]="'all'"
                    (selectionChange)="filterByArticle($event)"
                  >
                    <mat-option [value]="'all'">Tous les articles</mat-option>
                    <ng-container
                      *ngFor="let name of enumKeys; trackBy: trackByFn"
                    >
                      <mat-option [value]="name">
                        {{ ThemeArticle[name] }}</mat-option
                      >
                    </ng-container>
                  </mat-select>
                </mat-form-field>
              </div>
              <mat-progress-spinner *ngIf="loadingArticles; else articlesList">
                class="justify-items-center" [diameter]="80"
                [mode]="'indeterminate'"></mat-progress-spinner
              >
              <ng-template #articlesList>
                <div
                  class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-8 sm:mt-10"
                >
                  <ng-container
                    *ngIf="filteredArticles?.length; else noArticles"
                  >
                    <ng-container
                      *ngFor="
                        let article of filteredArticles;
                        trackBy: trackByFn
                      "
                    >
                      <fuse-card class="flex flex-col max-w-80 w-full relative">
                        <div *ngIf="article?.image">
                          <a
                            class="flex flex-auto items-center min-w-0 h-full pr-7"
                            [routerLink]="[
                              '/actualites/articles',
                              article.nom | convertToSlug,
                              article.id,
                            ]"
                            rel="noopener noreferrer"
                          >
                            <img
                              class="object-cover cursor-pointer w-full h-50"
                              [src]="cloud_front + article?.image"
                              alt="Card cover image"
                            />
                          </a>
                        </div>
                        <div class="m-8">
                          <a
                            class="text-2xl font-semibold leading-tight cursor-pointer hover:text-[#4524CB] hover:underline"
                            [routerLink]="[
                              '/actualites/articles',
                              article.nom | convertToSlug,
                              article.id,
                            ]"
                            rel="noopener noreferrer"
                          >
                            {{ article?.nom }}
                          </a>
                          <div class="text-secondary font-medium text-md mt-1">
                            {{ ThemeArticle[article?.themeArticle] }}
                          </div>
                          <!-- <div class="flex items-center mt-6 " >
                    <div *ngIf="auteur[article.auteur]?.urlPhotoProfil">
                      <img (click)="
                      redirectionProfil(auteur[article.auteur]?.userId)"
                        class="w-10 h-10 rounded-full cursor-pointer"
                        [src]="cloud_front +auteur[article.auteur]?.urlPhotoProfil"
                        alt="Card cover image"
                      />
                    </div>
                    <div
                      *ngIf="!auteur[article.auteur]?.urlPhotoProfil"
                      class="w-10 h-10 rounded-full">
                      <div
                        class="flex items-center justify-center w-full h-full rounded-full text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200"
                      >
                        {{ auteur[article.auteur]?.userName.charAt(0) }}
                      </div>
                    </div>
                    <div class="flex flex-col ml-3" >
                      <span class="font-medium leading-none cursor-pointer" (click)="
                      redirectionProfil(auteur[article.auteur]?.userId)">
                        {{auteur[article.auteur]?.userName}}</span>
                    </div>
                  </div> -->
                        </div>
                      </fuse-card>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-template>
              <ng-template #noArticles>
                <div
                  class="flex flex-auto flex-col items-center justify-center"
                >
                  <mat-icon
                    class="icon-size-24"
                    [svgIcon]="'heroicons_outline:document-search'"
                  ></mat-icon>
                  <div
                    class="mt-6 text-2xl font-semibold tracking-tight text-secondary"
                  >
                    Aucun article trouvé !
                  </div>
                </div>
              </ng-template>
              <div *ngIf="totalPages > 1" class="pagination-container">
                <div class="z-10 sticky hidden lg:flex bottom-1 p-1 mt-8">
                  <div
                    class="flex items-center justify-center mx-auto space-x-2"
                  >
                    <!-- Show Previous button -->
                    <button
                      class="flex-shrink-0 bg-blue-500 text-white rounded-full py-2 px-4 transition duration-300 hover:bg-blue-600 focus:outline-none"
                      (click)="onPageChange(currentPage - 1)"
                      [disabled]="currentPage === 0"
                    >
                      Précédent
                    </button>

                    <!-- Show page buttons -->
                    <ng-container *ngFor="let page of displayedPages">
                      <button
                        class="flex-shrink-0 bg-blue-500 text-white rounded-full py-2 px-4 transition duration-300 hover:bg-blue-600 focus:outline-none"
                        *ngIf="page !== 'ellipsis'"
                        (click)="onPageChange(page)"
                        [class.current]="currentPage === page"
                      >
                        {{ page + 1 }}
                      </button>

                      <!-- Show ellipsis for compact view -->
                      <span *ngIf="page === 'ellipsis'" class="px-2">...</span>
                    </ng-container>

                    <!-- Show Next button -->
                    <button
                      class="flex-shrink-0 bg-blue-500 text-white rounded-full py-2 px-4 transition duration-300 hover:bg-blue-600 focus:outline-none"
                      (click)="onPageChange(currentPage + 1)"
                      [disabled]="currentPage === totalPages - 1"
                    >
                      Suivant
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="flex flex-col flex-auto col-span-1 overflow-hidden order-first md:order-last"
            >
              <div class="hidden lg:flex flex-col items-start">
                <h2
                  class="text-3xl md:text-xl font-extrabold tracking-tight center leading-7 text-center sm:leading-10"
                >
                  Voulez-vous être un meilleur investisseur?
                </h2>

                <button
                  class="rounded-lg mt-2 mb-2 mx-auto flex items-center"
                  mat-flat-button
                  [color]="'primary'"
                  (click)="redirectFormation()"
                >
                  Rejoignez notre formation
                </button>
              </div>
              <div class="flex flex-col flex-auto col-span-1">
                <table
                  *ngIf="populaires"
                  mat-table
                  [dataSource]="dataSource"
                  class="mat-elevation-z8"
                >
                  <!-- Actif Column -->
                  <ng-container matColumnDef="Trouver un actif">
                    <th mat-header-cell *matHeaderCellDef class="bg-indigo-100">
                      <div class="flex flex-row">
                        <p
                          class="text-base font-semibold p-3 pl-0 cursor-pointer"
                        >
                          Trouver un actif
                        </p>
                        <button [matMenuTriggerFor]="userActions">
                          <mat-icon
                            svgIcon="heroicons_outline:chevron-double-down"
                          ></mat-icon>
                        </button>
                        <mat-menu
                          class="bg-indigo-100 max-h-80"
                          [xPosition]="'before'"
                          #userActions="matMenu"
                        >
                          <div *ngFor="let actif of actifs">
                            <a
                              mat-menu-item
                              [routerLink]="[
                                '/actifs',
                                actif.referentiel.stockName,
                                actif.referentiel.isin,
                              ]"
                            >
                              <span class="flex flex-col leading-none mt-0">
                                <span>{{ actif.referentiel.stockName }}</span>
                              </span>
                            </a>
                          </div>
                        </mat-menu>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <a
                        class="hover:underline font-semibold"
                        [routerLink]="[
                          '/actifs',
                          element.referentiel.stockName,
                          element.referentiel.isin,
                        ]"
                      >
                        {{ element.referentiel.stockName }}
                      </a>
                      <br />
                      <p class="font-light">{{ element.referentiel.ticker }}</p>
                    </td>
                  </ng-container>

                  <!-- Watchlist Column -->
                  <ng-container matColumnDef="Watchlist">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="text-base font-semibold p-3 cursor-pointer bg-indigo-100"
                      (click)="afficherWatchlist()"
                    >
                      <div class="flex flex-row gap-2">
                        Watchlist
                        <mat-icon
                          svgIcon="heroicons_outline:plus-circle"
                          (click)="openWatchlist()"
                        ></mat-icon>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-right">
                      <p>{{ element.last | number: ".2-2" }}</p>
                      <p
                        *ngIf="element.change >= 0"
                        style="color: rgb(22, 161, 22)"
                      >
                        +{{ element.change | number: ".2-2" }}%
                      </p>
                      <p
                        *ngIf="element.change < 0"
                        style="color: rgb(237, 30, 30)"
                      >
                        {{ element.change | number: ".2-2" }}%
                      </p>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>
                </table>
                <table
                  *ngIf="watchlist"
                  mat-table
                  [dataSource]="dataSource1"
                  class="mat-elevation-z8"
                >
                  <!-- Actif Column -->
                  <ng-container matColumnDef="Trouver un actif">
                    <th mat-header-cell *matHeaderCellDef class="bg-indigo-100">
                      <div class="flex flex-row">
                        <p
                          class="text-base font-semibold p-3 cursor-pointer pl-0"
                          (click)="masquerPopulaire()"
                        >
                          Trouver un actif
                        </p>
                        <button [matMenuTriggerFor]="userActions">
                          <mat-icon
                            svgIcon="heroicons_outline:chevron-double-down"
                          ></mat-icon>
                        </button>
                        <mat-menu
                          class="bg-indigo-100 max-h-80"
                          [xPosition]="'before'"
                          #userActions="matMenu"
                        >
                          <div *ngFor="let actif of actifs">
                            <a
                              mat-menu-item
                              [routerLink]="[
                                '/actifs',
                                actif.referentiel.stockName,
                                actif.referentiel.isin,
                              ]"
                            >
                              <span class="flex flex-col leading-none">
                                <span>{{ actif.referentiel.stockName }}</span>
                              </span>
                            </a>
                          </div>
                        </mat-menu>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <a
                        class="hover:underline font-semibold"
                        [routerLink]="[
                          '/actifs',
                          element.referentiel.stockName,
                          element.referentiel.isin,
                        ]"
                      >
                        {{ element.referentiel.stockName }}
                      </a>
                      <br />
                      <p class="font-light">{{ element.referentiel.ticker }}</p>
                    </td>
                  </ng-container>

                  <!-- Watchlist Column -->
                  <ng-container matColumnDef="Watchlist">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="text-base font-semibold p-3 cursor-pointer bg-indigo-100"
                    >
                      <div class="flex flex-row gap-2">
                        Watchlist
                        <mat-icon
                          svgIcon="heroicons_outline:plus-circle"
                          (click)="openWatchlist()"
                        ></mat-icon>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-right">
                      <p>{{ element.last | number: ".2-2" }}</p>
                      <p
                        *ngIf="element.change >= 0"
                        style="color: rgb(22, 161, 22)"
                      >
                        +{{ element.change | number: ".2-2" }}%
                      </p>
                      <p
                        *ngIf="element.change < 0"
                        style="color: rgb(237, 30, 30)"
                      >
                        {{ element.change | number: ".2-2" }}%
                      </p>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>
                </table>

                <button
                  (click)="openWatchlist()"
                  *ngIf="watchlist"
                  class="flex flex-row items-center justify-center py-2 px-1 bg-indigo-100 text-indigo-800 dark:bg-white dark:bg-opacity-5 font-semibold mt-2 gap-2"
                >
                  <p>Ajouter un titre à votre watchlist</p>
                  <mat-icon svgIcon="heroicons_outline:plus-circle"></mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
